(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/hero-banner/assets/javascripts/hero-banner.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/hero-banner/assets/javascripts/hero-banner.js');
"use strict";


const Button = svs.ui.ReactButton;
const _svs$poker_react$comp = svs.poker_react.components.common.helpers,
  launchWebClient = _svs$poker_react$comp.launchWebClient,
  handleDownloadClick = _svs$poker_react$comp.handleDownloadClick;
const detectedDevice = svs.poker_react.data.clientDownloadLinks.detectedDevice;
const Hero = svs.components.lbUi.hero.Hero;
const _svs$poker_react$data = svs.poker_react.data.heroData,
  _svs$poker_react$data2 = _svs$poker_react$data.heroImage,
  heroImage = _svs$poker_react$data2 === void 0 ? {} : _svs$poker_react$data2,
  title = _svs$poker_react$data.title,
  body = _svs$poker_react$data.body;
const HeroBanner = () => React.createElement("section", null, React.createElement(Hero, {
  branding: "poker",
  className: "hero-banner",
  image: heroImage
}, React.createElement("h2", {
  className: "center-text poker-h2"
}, title), React.createElement("p", {
  className: "hero-body"
}, body), React.createElement("div", {
  className: "btn-container"
}, React.createElement(Button, {
  className: "btn-poker",
  onClick: () => launchWebClient(),
  transparent: true
}, "\xD6ppna pokerklienten"), detectedDevice && detectedDevice.showDevice && React.createElement(Button, {
  className: "btn-poker",
  onClick: () => handleDownloadClick(detectedDevice.device, detectedDevice.url),
  transparent: true
}, detectedDevice.text))));
setGlobal('svs.poker_react.components.HeroBanner', HeroBanner);

 })(window);